import axios from "../utils/axios";

export const getList = (includeNonValids = true) => {
    return axios.get(`/AutonomousCheckItemGroup/GetList`, { params: { includeNonValids } });
};

export const getCheckItemsByGroup = (payload) => {
    return axios.get(`/AutonomousCheckItemGroup/${payload}/checkItems`);
};

export const updateCIG = (payload) => {
    return axios.put(`/AutonomousCheckItemGroup/${payload.id}`, payload.data);
};

export const addCIG = (payload) => {
    return axios.post(`/AutonomousCheckItemGroup`, payload);
};

export const deleteCIG = (payload) => {
    return axios.delete(`/AutonomousCheckItemGroup/${payload}`);
};

//Check Item api

export const getListOfItems = () => {
    return axios.get(`/AutonomousCheckItem/GetList`);
};

export const updateCI = (payload) => {
    return axios.put(`/AutonomousCheckItem/${payload.id}`, payload.data);
};

export const addCI = (payload) => {
    return axios.post(`/AutonomousCheckItem`, payload);
};

export const deleteCI = (payload) => {
    return axios.delete(`/AutonomousCheckItem/${payload}`);
};

// Planned Maintenance 

export const getPlannedList = (includeNonValids = true) => {
    return axios.get(`/PlannedCheckItemGroup/GetList`, { params: { includeNonValids } });
};

export const getPlannedCheckItemsByGroup = (payload) => {
    return axios.get(`/PlannedCheckItemGroup/${payload}/checkItems`);
};

export const updatePlannedCIG = (payload) => {
    return axios.put(`/PlannedCheckItemGroup/${payload.id}`, payload.data);
};

export const addPlannedCIG = (payload) => {
    return axios.post(`/PlannedCheckItemGroup/Add`, payload);
};

export const deletePlannedCIG = (payload) => {
    return axios.delete(`/PlannedCheckItemGroup/${payload}`);
};

//Check Item api

export const getPlannedListOfItems = () => {
    return axios.get(`/PlannedCheckItem/GetList`);
};

export const updatePlannedCI = (payload) => {
    return axios.put(`/PlannedCheckItem/${payload.id}`, payload.data);
};

export const addPlannedCI = (payload) => {
    return axios.post(`/PlannedCheckItem/Add`, payload);
};

export const deletePlannedCI = (payload) => {
    return axios.delete(`/PlannedCheckItem/${payload}`);
};

export const getPlannedCheckItemFiles = (payload) => {
    return axios.get(`/PlannedCheckItem/${payload}/files`,{ responseType: "arraybuffer" });
};

export const addPlannedCheckItemFiles = (payload) => {
    return axios.post(`/PlannedCheckItem/${payload.checkItemId}/files`, payload.data);
};

export const deletePlannedCheckItemFiles = (payload) => {
    console.log(payload.fileNames)
    return axios.delete(`/PlannedCheckItem/${payload.checkItemId}/files`, { data: payload.fileNames });
};

export const getAutonomousCheckItemFiles = (payload) => {
    return axios.get(`/AutonomousCheckItem/${payload}/files`,{ responseType: "arraybuffer" });
};

export const addAutonomousCheckItemFiles = (payload) => {
    return axios.post(`/AutonomousCheckItem/${payload.checkItemId}/files`, payload.data);
};

export const deleteAutonomousCheckItemFiles = (payload) => {
    console.log(payload.fileNames)
    return axios.delete(`/AutonomousCheckItem/${payload.checkItemId}/files`, { data: payload.fileNames });
};
